"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_network(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "d59729a7-1af5-4218-b0eb-6f084b082705",
    "data-name": "network-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "8876429c-6b0b-4584-aecf-59b71585415a",
    x1: 70.38,
    y1: 128.97,
    x2: 121.53,
    y2: 180.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "network-hi"), /*#__PURE__*/React.createElement("g", {
    id: "8dfdc78e-6b74-4680-9893-67d0c66a3f81",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3704130a-54df-4b1b-a961-f65befb879e4",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a204b931-5bdb-47dd-a4fd-71d987c6828c",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "011de657-4b09-41b8-b1f4-600467cb6ad1",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5577932a-5ab2-485b-a7ab-bc4307cea679",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ad57ad4b-08d3-45ac-916a-1c7e3bd512af",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "50ae1aa2-4e70-49ab-9c1d-2840ced4a416",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a2784140-7281-4b21-99d8-cbffb2edcc29",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2936add7-45a6-4964-9c9a-b55295263321",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0fb69f54-4346-4b9e-806d-fdb83e8573c3",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "94e33287-5351-4ea8-9e1e-b12576a338ba",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d8745ca1-58c6-48e2-83f5-c1ebe804b73a",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "97660fc2-9341-44cb-9dbd-f508e1d2b0de",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d70db8aa-1a6d-4be6-bf25-d7d415affb8f",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e41bad9c-38e3-4cd4-8b31-782e83645e64",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "31f74c97-41ae-4d65-8bac-3cd711c8e513",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "969e16a0-b64d-4248-a0f1-a57630154427",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "43c3d162-3481-4d72-8ae2-f04070347e9f",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3058dfd3-582f-473c-b74c-0a2f527af0a7",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0d741a40-6229-4953-ba05-e51479c80868",
    "data-name": "Network_signal_ic_mid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f5ce69e0-92c0-4c0e-9991-4171fd3cc311",
    "data-name": "Network_signal_ic_mid"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 67.82,
    y1: 172.01,
    x2: 111,
    y2: 124.01,
    fill: "none",
    stroke: "#f4f4f4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124,
    y1: 172.01,
    x2: 81,
    y2: 124.01,
    fill: "none",
    stroke: "#f4f4f4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("line", {
    x1: 67.82,
    y1: 172.01,
    x2: 111,
    y2: 124.01,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124,
    y1: 172.01,
    x2: 81,
    y2: 124.01,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127,169.34l-25.64-28.62,12.63-14a4,4,0,1,0-5.95-5.35L96,134.73,84,121.34a4,4,0,1,0-6,5.34l12.57,14L64.84,169.33a4,4,0,1,0,5.95,5.35L96,146.7l25.06,28a4,4,0,0,0,6-5.34Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#8876429c-6b0b-4584-aecf-59b71585415a)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.08,133.73l-4.48,5L78,124.67a4,4,0,0,1-.88-1.7,4,4,0,0,0,.88,3.7l12.57,14,5.38-6Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.67,173a4,4,0,0,1-5.65-.31l-24.16-27-.9,1,25.06,28a4,4,0,0,0,6.84-3.64A4,4,0,0,1,126.67,173Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114,124.68l-12.63,14-5.38,6-25.17,28A4,4,0,0,1,64,171a4,4,0,0,0,6.83,3.65L96,146.7l5.38-6,12.63-14a4,4,0,0,0,.89-3.7A4,4,0,0,1,114,124.68Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,176a4,4,0,0,1-3.86-3L96,81.62,71.68,173A4,4,0,0,1,64,171L92.13,65A4,4,0,0,1,96,62h0a4,4,0,0,1,3.86,3l28,106a4,4,0,0,1-3.87,5Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,176a4,4,0,0,1-3.86-3L96,81.62,71.68,173A4,4,0,0,1,64,171L92.13,65A4,4,0,0,1,96,62h0a4,4,0,0,1,3.86,3l28,106a4,4,0,0,1-3.87,5Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.87,171,100.66,68H91.33L64,171A4,4,0,0,0,71.68,173L96,81.62,120.13,173a4,4,0,1,0,7.73-2Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.87,65A4,4,0,0,0,96,62h0a4,4,0,0,0-3.87,3l-.8,3h9.33Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.86,171a4,4,0,0,1-7.73.06L96,79.62,71.68,171A4,4,0,0,1,64,171h0A4,4,0,0,0,71.68,173L96,81.62,120.13,173a4,4,0,1,0,7.73-2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }))), /*#__PURE__*/React.createElement("path", {
    id: "0cde8957-7a2a-4595-9de1-531ed1540b30",
    "data-name": "<Pfad>",
    d: "M152.17,19.5a72.74,72.74,0,0,1,0,102.91",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "6a3e9f14-3190-4286-a2ae-9ff446b5603c",
    "data-name": "<Pfad>",
    d: "M136.6,34.39a52,52,0,0,1,0,73.53",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "7b8da48a-eea3-4fc6-9d27-87c0010794c7",
    "data-name": "<Pfad>",
    d: "M121.3,49.7a30.24,30.24,0,0,1,0,42.72",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "3f47c15e-b14e-4981-8350-bc4e60f10006",
    "data-name": "<Pfad>",
    d: "M38.9,19.5a72.74,72.74,0,0,0,0,102.91",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "b92b0982-2487-4980-8bef-5a6f32471674",
    "data-name": "<Pfad>",
    d: "M54.48,34.39a52,52,0,0,0,0,73.53",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "a6d3699b-ecbf-4c77-80b9-90c9ee4a3e07",
    "data-name": "<Pfad>",
    d: "M69.78,49.7a30.24,30.24,0,0,0,0,42.72",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.62,121.93a2.12,2.12,0,0,1-3.4-.52,2.14,2.14,0,0,0,3.4,2.52A74.68,74.68,0,0,0,175.5,70,74.65,74.65,0,0,1,153.62,121.93Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.86,70.16A53.94,53.94,0,0,1,138,107.44a2.12,2.12,0,0,1-3.4-.52,2.14,2.14,0,0,0,3.4,2.52A54,54,0,0,0,153.86,70.16Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.23,92.56a2.09,2.09,0,0,1-1.89-1.14,2.14,2.14,0,0,0,3.4,2.52,32.13,32.13,0,0,0,9.46-22.88c0-.33,0-.67,0-1a32.11,32.11,0,0,1-9.44,21.88A2.14,2.14,0,0,1,121.23,92.56Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,122.55a2.14,2.14,0,0,1-1.52-.63A74.65,74.65,0,0,1,15.51,70a74.68,74.68,0,0,0,21.88,54,2.14,2.14,0,0,0,3.4-2.52,2.09,2.09,0,0,1-1.89,1.14Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.48,108.07a2.14,2.14,0,0,1-1.52-.63A53.94,53.94,0,0,1,37.15,70.16,54,54,0,0,0,53,109.44a2.14,2.14,0,0,0,3.4-2.52,2.09,2.09,0,0,1-1.89,1.14Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.78,92.56a2.14,2.14,0,0,1-1.52-.63,32.11,32.11,0,0,1-9.44-21.88c0,.33,0,.67,0,1a32.13,32.13,0,0,0,9.46,22.88,2.14,2.14,0,0,0,3.4-2.52,2.09,2.09,0,0,1-1.89,1.14Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 45.23,
    x2: 96,
    y2: 64.5,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))))))))))))))))))), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }));
}

var _default = ic_network;
exports.default = _default;